export default class EnquiryService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  getEnquiry(entityId, contactId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/get/${entityId}/${contactId}`);
  }

  updateOwner(enquiryId, ownerId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/updateOwner/${enquiryId}/${ownerId}`);
  }

  editEnquiry(enquiry) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/edit', enquiry);
  }

  canConfirmEnquiry(enquiry) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/canconfirm', enquiry);
  }

  listEnquiries(filterParams) {
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;
    query += `&entityId=${filterParams.entityId}`;

    if (filterParams.subject) {
      query += `&subject=${filterParams.subject}`;
    }

    if (filterParams.contactName) {
      query += `&contactName=${filterParams.contactName}`;
    }

    if (filterParams.ownerName) {
      query += `&ownerName=${filterParams.ownerName}`;
    }

    if (filterParams.status) {
      query += `&enquiryState=${filterParams.status}`;
    }

    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/enquiry/list' + query);
  }

  updateContactState(entityId, contactId, state) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/contact/update/${entityId}/${contactId}/${state}`);
  }

  duplicate(enquiryId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/duplicate/${enquiryId}`);
  }

  notifyFinance(enquiryId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/notifyFinance/${enquiryId}`);
  }

  addShowroomEntry(entry) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/addshowroomentry', entry);
  }

  removeTradeIn(enquiryId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/removetradein/${enquiryId}`);
  }  

  addExistingTradeIn(currentEnquiryId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/addexistingtradein/${currentEnquiryId}`);
  }   
  
  closeLinkedEnquiries(enquiryIds) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/closeLinkedEnquiries/?enquiryIds=${enquiryIds}`);
  }     

  sendWebLeadFollowUpEmail(data) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/enquiry/sendwebleadfollowupemail/`, data);
  }       

  addPayment(enquiryId, payment) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/enquiry/addpayment/${enquiryId}`, payment);
  }

  editPayment(payment) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/enquiry/editpayment/`, payment);
  }  

  deletePayment(enquiryPaymentId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquiry/deletepayment/${enquiryPaymentId}`);
  }    
}



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiry.service.js